const CONDITION_TYPES = {
  LOCAL: 'local',
  ACTION_SEQUENCER_RESULTS: 'sequencer',
  DATALINK: 'document',
  JSON: 'json',
  HAS_STRIPE_ROLE: 'hasStripeRole',
  DOES_NOT_HAVE_STRIPE_ROLE: 'doesNotHaveStripeRole',
  HAS_ROLE: 'hasRole',
  DOES_NOT_HAVE_ROLE: 'doesNotHaveRole',
  HAS_CLAIM: 'hasClaim',
  DOES_NOT_HAVE_CLAIM: 'doesNotHaveClaim',
  HAS_PRODUCT_ID: 'hasProductId',
  DOES_NOT_HAVE_PRODUCT_ID: 'doesNotHaveProductId',
  HAS_ACTIVE_SUBSCRIPTION: 'hasActiveSubscription',
  DOES_NOT_ACTIVE_SUBSCRIPTION: 'doesNotHaveActiveSubscription',
  LOGGED_IN: 'loggedIn',
  LOGGED_OUT: 'loggedOut',
  HAS_DOCUMENTS: 'hasDocuments',
  FIRST_DOCUMENT_IS_SELECTED: 'firstDocument',
  LAST_DOCUMENT_IS_SELECTED: 'lastDocument',
  HAS_VERIFIED_EMAIL: 'emailVerified',
  HAS_VERIFIED_PHONE: 'phoneVerified',
  HAS_UNIQUE_EMAIL: 'emailUnique',
  ACCESS_NONE: 'contentTypeNoAccess',
  ACCESS_READONLY: 'contentTypeReadOnlyAccess',
  ACCESS_READWRITE: 'contentTypeReadWriteAccess',
  VALIDATION: 'VALIDATION',
  FORM_IS_VALID: 'formIsValid',
  FORM_IS_NOT_VALID: 'formIsNotValid',
  FORM_FIELD_IS_NOT_VALID: 'formFieldIsNotValid',
  FORM_VALUE_IS_MATCHED: 'formValueIsMatched',
  JAVASCRIPT_FUNCTION_RESULT: 'executeCode',
  ACTION_SEQUENCE_RUNNING: 'actionSequenceRunning',
  ACTION_SEQUENCE_NOT_RUNNING: 'actionSequenceNotRunning'
};

export default CONDITION_TYPES;
